<section class="reservation container-fluid">
    <div
        class="reservation__content d-flex flex-column align-items-center px-2 py-4"
    >
        <div class="reservation__content__icon">
            <img [src]="'images/edit_typ.svg' | cdn" alt="Edit icon" />
        </div>
        <div class="reservation__content__text my-3 text-center">
            <h2 class="reservation__content__text__question">
                {{
                    'fe_details_step5_cancel_reservation_reservation_content_text'
                        | translate
                }}
            </h2>
        </div>
        <div class="reservation__content__button mb-1">
            <fe-button
                [style]="'cancel'"
                (click)="swal()"
                [loading]="loadingBtn"
                >{{
                    'fe_details_step5_cancel_reservation_reservation_content_button'
                        | translate
                }}</fe-button
            >
        </div>
    </div>
</section>

<swal
    #cancelTemplate
    [showConfirmButton]="true"
    [showCancelButton]="true"
    [confirmButtonText]="confirmButtonText"
    [cancelButtonText]="cancelButtonText"
    [customClass]="{ popup: 'custom-swal-popup-cancel' }"
    [showCloseButton]="true"
>
    <div *swalPortal="undefined">
        <div class="cancel container-fluid">
            <span class="cancel__title">{{
                'fe_details_step5_cancel_template_title' | translate
            }}</span>
            <span class="cancel__subtitle"
                >{{ 'fe_details_step5_cancel_template_subtitle' | translate }}
            </span>
        </div>
    </div>
</swal>
